import React from "react";

export default function Container({ styles, children }) {

    return (
        <div className={`container ${styles}`}>
            {children}
        </div>
    )
}